import type { BulkScenarioTitleFormat } from "in_queue/analytics";

const SEPARATOR_RUN = /[+\-_]+/g;
const WHITESPACE_RUN = /\s+/g;

/** Turn each run of +, - or _ into one space and tidy whitespace; keep the title when nothing would be left. */
export const humanizeScenarioTitle = (title: string): string => {
    const humanized = title
        .replace(SEPARATOR_RUN, " ")
        .replace(WHITESPACE_RUN, " ")
        .trim();
    return humanized === "" ? title : humanized;
};

interface ScenarioTitleFormatInfo {
    readonly key: BulkScenarioTitleFormat;
    readonly label: string;
    readonly description?: string;
}

/** A change to the selected titles: applied at once, or with text the user types first. */
export type ScenarioTitleFormat = ScenarioTitleFormatInfo &
    (
        | {
              readonly kind: "instant";
              readonly apply: (title: string) => string;
          }
        | {
              readonly kind: "text";
              readonly apply: (title: string, text: string) => string;
          }
    );

export type TextScenarioTitleFormat = Extract<
    ScenarioTitleFormat,
    { readonly kind: "text" }
>;

export const SCENARIO_TITLE_FORMATS: ReadonlyArray<ScenarioTitleFormat> = [
    {
        key: "humanize",
        kind: "instant",
        label: "Humanize titles",
        description: "Replace special characters (+, -, _) with spaces",
        apply: humanizeScenarioTitle
    },
    {
        key: "prefix",
        kind: "text",
        label: "Add prefix",
        apply: (title, text) => `${text.trim()} ${title}`
    },
    {
        key: "suffix",
        kind: "text",
        label: "Add suffix",
        apply: (title, text) => `${title} ${text.trim()}`
    }
];
